const typesDocuments = {
  LEGISLATION: 'Legislation',
  ADMIN_LEGISLATION: 'AdminLegislation',
  CCR_RAPORT: 'CcrReport',
  FOLLOWUP_CCR_RAPORT: 'FollowupCcrReport',
  ADDITIONAL_DOCUMENT: 'AdditionalDocuments',
  DECISION_DOCUMENT: 'DecisionDocument',
  INTERNAL_DOCUMENT: 'InternalDocument',
  LITIGATION: 'Litigation',
  LITIGATION_DOCUMENT: 'LitigationDocument',
  LITIGATION_TERM: 'LitigationTerm',
  AUDIT: 'audit',
  AUDIT_TERM: 'AuditTerm',
  DOCUMENTS: 'documents'
};

const documentsMessage = {
  LEGISLATION: 'legislație',
  ADMIN_LEGISLATION: 'legislație',
  CCR_RAPORT: 'raport CCR',
  FOLLOWUP_CCR_RAPORT: 'raport de followup',
  ADDITIONAL_DOCUMENT: 'document aditional',
  DECISION_DOCUMENT: 'document de modificare masura',
  INTERNAL_DOCUMENT: 'document intern'
};

export { typesDocuments, documentsMessage };
